/* MMS special order (added 2026-10-09; backorder support added 2026-10-15).
   Dawn's product-info.js resets the Add to Cart label to window.variantStrings.addToCart
   on every variant change. This copies the label rendered by Liquid for the newly
   selected variant (e.g. "Add To Cart – Special Order") back onto the live button. */
(function () {
  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.html) return;
      var src = data.html.getElementById('ProductSubmitButton-' + data.sectionId);
      if (!src) return;
      var srcLabel = src.querySelector('span');
      document.querySelectorAll('product-info').forEach(function (pi) {
        if (pi.sectionId !== data.sectionId) return;
        var form = pi.productForm;
        var btn = form && form.submitButton;
        if (!btn || !form.submitButtonText) return;
        var idInput = form.querySelector('input[name="id"]');
        if (data.variant && idInput && String(idInput.value) !== String(data.variant.id)) return;
        btn.classList.toggle('mms-special-order-btn', src.classList.contains('mms-special-order-btn'));
        btn.classList.toggle('mms-backorder-btn', src.classList.contains('mms-backorder-btn'));
        /* Backorder line item property (added 2026-10-15): copy the hidden input state for the new variant */
        var boSrc = data.html.getElementById('BackorderProp-' + data.sectionId);
        var boDst = form.querySelector('.mms-backorder-prop');
        if (boDst) {
          var boVal = boSrc && !boSrc.disabled ? boSrc.value : '';
          boDst.value = boVal;
          boDst.disabled = !boVal;
        }
        if (!btn.hasAttribute('disabled') && srcLabel) {
          form.submitButtonText.innerHTML = srcLabel.innerHTML.trim();
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
